import {
  IAccessTypParam,
  IPaywallParam,
} from '@src/Umbraco/Components/PaywallChecker/PaywallChecker';
import {NavigationParams} from './navigationParams.type';

export enum WatchSource {
  LIVESTREAM = '1',
  VIMEO = '2',
  LOCAL = '3',
  BYTEPLUS = '4',
}

interface PaywallParams {
  paywallData: {
    accessType?: IAccessTypParam;
    paywall?: IPaywallParam;
  };
}

export interface PlaybackParams {
  source: WatchSource;
  sourceUrl?: string;
  title: string;
  isFullscreen?: boolean;
  url: string;
  videoUrl?: string;
  /**
   * Historical Vimeo videoId for backward compatibility (should be cleaned up when Vimeo is no more used)
   */
  videoId?: string;
  /**
   * Vimeo videoId (should be cleaned up when Vimeo is no more used)
   */
  vimeoId?: string;
  /**
   * Live Event ID & VimeoId
   */
  liveEventId?: string;
  /** Byteplus videoId */
  byteplusId?: string;
  /** Youtube videoId */
  youtubeId?: string;

  id: string;
  isLive?: boolean;
  list?: {
    id: string;
  };
}

export interface WatchNavigationParams {
  type: 'player';
}

export type WatchPageRouteParams = PlaybackParams &
  PaywallParams &
  NavigationParams &
  WatchNavigationParams;
